import {
  getLoginSuccess,
  updateBranches,
  UpdateEmailIntegration,
  updatePermissions,
} from "../Store/Actions";
import {
  ChangeGlobalInactivityHandler,
  GlobalNavigate,
  SetGlobalAccountReducer,
  SetGlobalAccountUuidReducer,
  SetGlobalCategoriesReducer,
  SetGlobalCompanyId,
  SetGlobalFullAccess,
} from "./Middleware.Helper";
import {showError} from "./Tostify.Helper";
import {NavigationSourcesEnum} from "../enums";
import {GetNylasUserDetails} from "../Services";
import {VitallyVerifyUser} from "./VitallyVerifyUser.Helper";
import {ScheduleTokenRefresh} from "./Token.Helper";

export const AfterLoginHandler = async ({
  response,
  translationPath,
  t,
  setState,
  // state,
  dispatch,
  query,
  setToken,
  firstSelectedBranch,
  setFirstSelectedBranch,
  forcedBranchUuid,
}) => {
  const {results} = response.data;

  if (results) dispatch(getLoginSuccess(results));

  if (results && results.employee_categories) {
    localStorage.setItem(
      "employee_categories",
      JSON.stringify(results.employee_categories)
    );
    SetGlobalCategoriesReducer(results.employee_categories);
  }

  const firstAccessibleCompany =
    (results.companies &&
      results.companies.find((company) => {
        const branch_uuid =
          forcedBranchUuid ||
          query.get("branch_uuid") ||
          query.get("company_uuid");
        if (branch_uuid)
          return company.can_access && company.uuid === branch_uuid;
        else return company.can_access;
      })) ||
    null;
  if (!firstAccessibleCompany) {
    showError(t(`${translationPath}cant-access-description`));
    setState((items) => ({
      ...items,
      submitted: false,
    }));

    return;
  }
  if (firstAccessibleCompany) {
    dispatch(
      updatePermissions({
        permissions: firstAccessibleCompany.permission || [],
        full_access: firstAccessibleCompany.full_access,
      })
    );
    SetGlobalFullAccess(firstAccessibleCompany.full_access);
  }
  dispatch(
    updateBranches({
      results: results.companies,
      totalCount: results.companies.length,
    })
  );
  setToken(results.token);
  if (results.with_session_expiry_control) {
    ChangeGlobalInactivityHandler({
      newTimeoutDuration: results.session_expiry * 60 * 60 * 1000,
      newTurnOffInactivityLogoutValue: false,
    });
  } else {
    ChangeGlobalInactivityHandler({
      newTimeoutDuration: undefined,
      newTurnOffInactivityLogoutValue: true,
    });
  }
  localStorage.setItem("system_user", JSON.stringify(results));
  localStorage.setItem("account_uuid", results.account_uuid);
  localStorage.setItem("user_token", results.token);
  localStorage.setItem("user_token_expiry", results.token_expiry);
  ScheduleTokenRefresh(dispatch);
  localStorage.setItem(
    "company_uuid",
    (firstAccessibleCompany && firstAccessibleCompany.uuid) || null
  );
  SetGlobalAccountReducer(results);
  SetGlobalAccountUuidReducer(results.account_uuid);
  SetGlobalCompanyId(
    (firstAccessibleCompany && firstAccessibleCompany.uuid) || null
  );
  if (results.account_uuid) {
    // ChurnZero Setup
    window?.ChurnZero?.push(["setAppKey", process.env.REACT_APP_CHURNZERO_KEY]);
    window?.ChurnZero?.push(["setContact", results.account_uuid, results.uuid]);
    window?.ChurnZero?.push(["trackEvent", "Login", "Successful login", 1, {}]);
    window?.ChurnZero?.push([
      "setAttribute",
      "contact",
      {
        "First Name": results.first_name?.en,
        "Last Name": results.last_name?.en,
        Email: results.email,
        "Is Employee": results.is_employee,
      },
    ]);
    VitallyVerifyUser(results);
  }
  if (
    !firstSelectedBranch ||
    (firstAccessibleCompany &&
      firstSelectedBranch.uuid !== firstAccessibleCompany.uuid)
  )
    setFirstSelectedBranch(firstAccessibleCompany || null);
  const source = query.get("source");
  if (
    source &&
    +source === NavigationSourcesEnum.FromVisaDashboardToSelfService.key
  )
    GlobalNavigate(`/home/visa-requests`);
  // Get user details for email integration if a user is authenticated with Nylas
  const nylasUserDetails = await GetNylasUserDetails({
    user_uuid: results.uuid,
  });

  window.ChurnZero?.push([
    "setAttribute",
    "contact",
    "Connected to nylas email integration",
    nylasUserDetails?.data?.body &&
    nylasUserDetails?.data?.body?.sync_state === "running"
      ? "Yes"
      : "No",
  ]);

  if (
    nylasUserDetails &&
    nylasUserDetails.status === 200
    // &&
    // nylasUserDetails.data?.body
  )
    dispatch(UpdateEmailIntegration(nylasUserDetails.data.body));
  else dispatch(UpdateEmailIntegration(null));
};
